/**
 * Creates and downloads a csv file from a given url
 *
 * @param csvFileData - reponse data from a post to the BE
 * @param fileName - name of the file to be created
 */
export function downloadCSV(csvFileData: string, fileName: string): void {
    // Create a blob object from the csv data and get url of blob object
    const csvBlob = new Blob([csvFileData], { type: "text/csv" });
    const csvUrl = URL.createObjectURL(csvBlob);

    // Create an anchor element and set its href and download attributes
    const link = document.createElement("a");
    // eslint-disable-next-line iventis/no-href-assignments
    link.href = csvUrl;
    link.download = fileName;

    // Append the anchor element to the document body and simulate a click
    document.body.appendChild(link);
    link.click();

    // Remove the anchor element from the document body, use settimeout to wait until after the click event has been triggered
    setTimeout(() => document.body.removeChild(link), 0);
    URL.revokeObjectURL(csvUrl);
}
